<template>
  <div class='map-container'>
    <div class='not-selected-locations-container'>
      <v-btn style='margin: auto; display: block; margin-top: 5px;' @click="showAddPopup()" color="success">
        Add Location
      </v-btn>
      <div :key="loc.id" class='booth-location-item' v-for='loc in sortedLocations'>
        <v-flex class='loc-item' v-bind:class="{invalid: !isOnMap(loc), active: selectedLocation === loc}">
          {{ loc.name }}
          <div style='margin-left: auto'>
            <v-btn
              v-if='!isOnMap(loc)'
              small
              color="success"
              fab flat
              slot="activator"
              @click="selectLocation(loc)"
            >
              <v-icon>location_searching</v-icon>
            </v-btn>
            <v-btn
              v-if='isOnMap(loc)'
              small
              color="success"
              fab flat
              slot="activator"
              @click="removeLocationFromMap(loc)"
            >
              <v-icon>location_disabled</v-icon>
            </v-btn>
            <v-btn
              small
              color="success"
              fab flat
              slot="activator"
              @click="showAddPopup(loc)"
            >
              <v-icon>edit</v-icon>
            </v-btn>
          </div>
        </v-flex>
      </div>
    </div>

    <div class='map-image' v-html="getMapSvg" />
    <!-- <div class='selection-popup' v-if='selectedLocation'>
      Selected location: {{selectedLocation.name}}
      <v-btn
        small
        fab flat
        slot="activator"
        @click="deselectLocation()"
      >
        <v-icon>close</v-icon>
      </v-btn>
    </div> -->
    <div class='selection-popup' v-if='hoveredSponsor'>
      Sponsor: {{hoveredSponsor.company}}
    </div>
    <div class='selection-popup' v-if='hoveredLocation'>
      Location: {{hoveredLocation.name}} [{{hoveredLocation.uid}}]
    </div>

    <v-dialog v-model="popupVisible" max-width="600px">
      <v-card class="pa-2" >
        <v-card-title>
          <v-flex>
            <content-field
              label="Name"
              :error="$v.currentLocation.name"
              v-model="currentLocation.name"/>
          </v-flex>
          <v-flex>
            <content-field
              label="Description"
              :error="$v.currentLocation.description"
              v-model="currentLocation.description"/>
          </v-flex>
        </v-card-title>
        <v-card-actions>
          <v-btn :disabled='$v.currentLocation.$invalid' color="success" flat @click="addLocation">Save</v-btn>
          <v-btn v-if='currentLocation.id' color="error" flat @click="deleteLocation">Delete</v-btn>
          <v-btn color="warning" flat @click="hideAddPopup">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import ContentField from '@/components/shared/ContentField/index.vue'
import uuidv1  from 'uuid/v1'

function buildBooth(sponsor, number) {
  number = parseInt(number)
  const location = (sponsor.boothLocations || []).find(l => parseInt(l.boothNumber) === number)
  return {
    id: `${sponsor.id}_${number}`,
    sponsor: sponsor,
    number
  }
}

export default {
  name: 'FloorPlan',
  components: {
    ContentField
  },
  data () {
    return {
      locationIds: [],
      boothIds: [],
      selectedLocation: null,
      hoveredLocation: null,
      hoveredSponsor: null,
      popupVisible: false,
      currentLocation: {
        description: '',
        name: '',
        uid: ''
      } }
  },
  validations: {
    currentLocation: {
      name: { required }
    }
  },
  computed: {
    ...mapGetters([
      'sponsorsList',
      'getMapLocations',
      'getMapSvg'
    ]),
    sortedLocations () {
      return this.getMapLocations.sort((a, b) => {
        const ia = this.isOnMap(a)
        const ib = this.isOnMap(b)
        const an = a.name.toUpperCase()
        const bn = b.name.toUpperCase()

        if ((ia && ib) || (!ia && !ib)) {
          if (an < bn) return -1
          if (an > bn) return 1
          return 0
        }
        if (ia) return 1
        return -1
      })
    }
  },
  methods: {
    ...mapActions([
      'addMapLocation',
      'deleteMapLocation',
      'fetchSponsorsList',
      'fetchMapSvg',
      'fetchMapLocations',
      'editSponsor'
    ]),
    isOnMap (l) {
      return this.locationIds.indexOf(l.uid) > -1
    },
    async removeLocationFromMap (loc) {
      loc.uid = uuidv1()
      await this.saveLocation(loc)
    },
    showAddPopup (item) {
      this.popupVisible = true
      this.currentLocation = item || {
        description: '',
        name: '',
        uid: uuidv1()
      }
    },
    hideAddPopup (item) {
      this.$v.$reset()
      this.popupVisible = false
    },
    async addLocation () {
      this.$v.currentLocation.$touch()
      if (this.$v.currentLocation.$invalid) return false

      await this.saveLocation(this.currentLocation)
      this.hideAddPopup()
    },
    async deleteLocation () {
      await this.deleteMapLocation(this.currentLocation.id)
      await this.fetchMapLocations()
      this.computeMarkers()
      this.hideAddPopup()
    },
    selectLocation (item) {
      if (item === this.selectedLocation) return this.deselectLocation()
      this.selectedLocation = item
      for (let id of this.locationIds) {
        const el = document.getElementById(`location-${id}`)
        el.classList.add('can-select')
      }
    },
    deselectLocation () {
      this.selectedLocation = null
      for (let el of document.querySelectorAll('.can-select')) {
        el.classList.remove('can-select')
      }
    },
    detectPriority (s1, s2) {
      if (!s1) return s2
      if (s1.company.indexOf('Available') > -1) return s2
      if (s1.company.indexOf('Reserved') > -1) return s2
      return s1
    },
    async saveLocation (loc) {
      if (loc.id) await this.deleteMapLocation(loc.id)
      await this.addMapLocation(loc)
      await this.fetchMapLocations()
      this.computeMarkers()
    },
    async clickLocation (id) {
      if (this.selectedLocation) {
        const old = this.getMapLocations.find(l => l.uid === id)
        if (old) await this.removeLocationFromMap(old)
        this.selectedLocation.uid = id
        await this.saveLocation(this.selectedLocation)
        this.deselectLocation()
      }
    },
    computeMarkers () {
      const selectedLocationsTable = {}

      this.getMapLocations
        .filter(l => l.uid) // to prevent possible bugs
        .forEach(l => selectedLocationsTable['l' + l.uid] = l)

      for (let id of this.locationIds) {
        const el = document.getElementById(`location-${id}`)
        const loc = selectedLocationsTable['l' + id]
        if (loc) el.classList.add('map-booth-selected')
        else el.classList.remove('map-booth-selected')
      }
    },
    initMap () {
      const selectedTable = {}

      this.sponsorsList
        .filter((s) => s.boothNumber.toString().length > 0)
        .forEach(sponsor =>
          (sponsor.boothNumber)
            .split('&')
            .map(n => parseInt(n))
            .filter(n => n > -1) // allow 0 booth?
            .forEach(n => {
              selectedTable[n] = this.detectPriority(selectedTable[n], sponsor)
            })
        )

      console.log('g[id]', document.querySelectorAll('g[id]'))

      for (let el of document.querySelectorAll('g[id]')) {
        const [type, id] = el.id.split('-')
        if (type === 'booth') this.boothIds.push(id)
        if (type === 'location') this.locationIds.push(id)
      }

      console.log('this.boothIds', this.boothIds)
      console.log('this.locationIds', this.locationIds)

      for (let id of this.boothIds) {
        const el = document.getElementById(`booth-${id}`)
        el.classList.add('map-booth')
        if (selectedTable[id]) {
          el.classList.add('map-booth-selected')

          el.addEventListener('mouseenter', () => {
            this.hoveredSponsor = selectedTable[id]
          })
        }

        el.addEventListener('mouseleave', () => {
          this.hoveredSponsor = null
        })
      }
      console.log('locationIds', this.locationIds)

      for (let id of this.locationIds) {
        const el = document.getElementById(`location-${id}`)
        el.classList.add('map-booth')

        el.addEventListener('click', () => {
          this.clickLocation(id)
        })

        el.addEventListener('mouseenter', () => {
          this.hoveredLocation = this.getMapLocations.find(l => l.uid === id)
        })

        el.addEventListener('mouseleave', () => {
          this.hoveredLocation = null
        })
      }

      this.computeMarkers()
    }
  },
  async mounted () {
    await Promise.all([
      this.fetchMapSvg(),
      this.fetchMapLocations(),
      this.fetchSponsorsList({
        itemsOnPage: 9999,
        filter: true,
        fieldName: 'Status',
        operatorName: 'Equals',
        fieldVal: 'Published'
      })
    ])
    setTimeout(this.initMap)
  }
}
</script>

<style lang="scss">
.map-container {
  display: flex;
}

.loc-item {
  display: flex;
  align-items: center;
  padding-left: 5px;
  border-radius: 5px;
  margin-top: 5px;

  &.invalid {
    background: #ecebe9;
  }

  &.active {
    background: #82b1ff;
  }
}

.selection-popup {
  position: fixed;
  top: 20px;
  right: 20px;
  background: #1976d2;
  color: white;
  text-align: center;
  padding: 10px;
}

.map-image {
  width: 100%;
  height: calc(100vh - 50px);

  svg {
    max-height: 100%;
  }
}

.map-booth-description {
  position: fixed;
  bottom: 20px;
  right: 20px;
  display: none;
  background: white;
  border: 1px solid black;
  z-index: 10;
  padding: 5px;
}

.map-booth {
  cursor: pointer;
}

.map-booth-selected {
  path {
    fill: green;
  }
}

.can-select {
  cursor: pointer;

  path {
    fill: blue;
  }

  &.map-booth-selected path {
    fill: yellow;
  }
}

.not-selected-locations-container {
  padding-top: 20px;
  padding-right: 5px;
  width: 300px;
  height: calc(100vh - 50px);
  overflow-y: auto;
  border-right: #333 solid 1px;
}

.not-selected-locations-title {
  height: 20px;
  font-weight: bold;
  color: #333;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Sponsors/FloorPlan/index.vue